document.addEventListener("DOMContentLoaded", function () {
  if (typeof Shopify != "undefined") {
    const locale = Shopify.locale;
    // TODO: Add translations to locales - hu.json
    const wishlistTranslations = {
      hu: {
        wishlist: "Kedvencek",
        wishlist_empty: "Üres a kedvencek listád.",
        wishlist_add: "Hozzáadás a kedvencekhez",
        wishlist_added: "Hozzáadva a kedvencekhez",
        wishlist_login: "Bejelentkezés",
        wishlist_search: "Keresés",
        wishlist_url_copied: "A kívánságlista URL-címe sikeresen másolva!",
        wishlist_added_to_cart: "Termék hozzáadva a kosárhoz.",
        wishlist_move_to_cart: "Kosárba vele",
        wishlist_share: "Nézd meg a kedvenceimet a Szputnyik oldalán!",
        wishlist_remove: "Eltávolítás",
        wishlist_removing: "Eltávolítás a kedvencek közül...",
        wishlist_removed: "A terméket sikeresen eltávolítottuk a kívánságlistáról.",
        wishlist_error: "Ez a kedvencek lista nem található.",
        wishlist_error_product: "A termék részletei nem találhatók!",
        share_buttons: [
          "Megosztás Facebookon",
          "Megosztás Twitteren",
          "Megosztás Whatsupon",
          "Megosztás e-mailben",
          "Link másolása",
        ],
      },
    };

    if (locale === "hu") {
      const wishlistButton = document.querySelector(".wishlist-engine");

      function updateWishlistButton() {
        const wishlistButtonText = document.querySelector(".wishlist-text");
        if (wishlistButtonText) {
          if (wishlistButton.getAttribute("data-added") === "true") {
            wishlistButtonText.textContent = wishlistTranslations.hu.wishlist_added;
          } else {
            wishlistButtonText.textContent = wishlistTranslations.hu.wishlist_add;
          }
        }
      }

      function updateWishlistPage() {
        const wishlistTitle = document.querySelector(".wishlist-heading");
        const wishlistInput = document.querySelector("#wishlist-input");
        const wishlistMoveToCart = document.querySelector(".wishlist-move-cart");
        const wishlistEmpty = document.querySelector(".wishlsitnoitem");
        const shareButtons = document.querySelectorAll(".wishlist-share-triger");

        if (wishlistTitle) {
          wishlistTitle.textContent = wishlistTranslations.hu.wishlist;
        }
        if (wishlistInput) {
          wishlistInput.placeholder = wishlistTranslations.hu.wishlist_search;
        }
        if (wishlistMoveToCart) {
          wishlistMoveToCart.textContent = wishlistTranslations.hu.wishlist_move_to_cart;
        }
        if (wishlistEmpty) {
          wishlistEmpty.textContent = wishlistTranslations.hu.wishlist_empty;
        }
        if (shareButtons && shareButtons.length > 0) {
          shareButtons.forEach((button, i) => {
            button.title = wishlistTranslations.hu.share_buttons[i];
          });
        }
      }

      function updateWishlistModal() {
        const wishlistTitle = document.querySelector(".wishlist-heading");
        const wishlistInput = document.querySelector("#wishlist-input");
        const wishlistMoveToCart = document.querySelector(".wishlist-move-cart");
        const wishlistLogin = document.querySelector(".sewp-right-data a");
        const wishlistEmpty = document.querySelector(".wishlsitnoitem");
        const shareButtons = document.querySelectorAll(".wishlist-share-triger");

        if (wishlistTitle) wishlistTitle.textContent = wishlistTranslations.hu.wishlist;
        if (wishlistInput) wishlistInput.placeholder = wishlistTranslations.hu.wishlist_search;
        if (wishlistLogin) wishlistLogin.textContent = wishlistTranslations.hu.wishlist_login;
        if (wishlistMoveToCart) wishlistMoveToCart.textContent = wishlistTranslations.hu.wishlist_move_to_cart;
        if (wishlistEmpty) wishlistEmpty.textContent = wishlistTranslations.hu.wishlist_empty;
        if (shareButtons && shareButtons.length > 0) {
          shareButtons.forEach((button, i) => {
            button.title = wishlistTranslations.hu.share_buttons[i];
          });
        }
      }

      const observerCallback = (mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((node) => {
              if (node.id === "sewp-engine-popup" || (node.classList && node.classList.contains("wishlsitnoitem"))) {
                updateWishlistModal();
              }
              if (node.classList && node.classList.contains("wishlist-container")) {
                updateWishlistPage();
              }
              if (node.classList && node.classList.contains("wishlist-engine-button")) {
                updateWishlistButton();
              }
            });
          }
        });
      };

      const observer = new MutationObserver(observerCallback);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
});
